import { PrimitiveType } from "../../../api/api";

export type ExpressionModel = {
	Type: string;
} & Record<string, any>;

export const PRIMITIVE_TYPES_ALL: PrimitiveType[] = Object.values(PrimitiveType).filter((x) => isNaN(Number(x)));

export const PRIMITIVE_TYPES_WITHOUT_COLLECTION: PrimitiveType[] = PRIMITIVE_TYPES_ALL.filter(
	(x) => x !== PrimitiveType.Collection && x !== PrimitiveType.Object && x !== PrimitiveType.Ref
);

export const PRIMITIVE_TYPES_WITHOUT_REF: PrimitiveType[] = PRIMITIVE_TYPES_ALL.filter((x) => x !== PrimitiveType.Ref);


